import SharedStorageInterface from "../SharedStorageInterface.js"

class SharedStorageQiankun extends SharedStorageInterface {
    constructor(storageAgent) {
        super();
        this.storageAgent = storageAgent;
    }

    get = async (key=null) => {
        return await this.storageAgent.get(key);
    }

    set = async (key, value) => {
        await this.storageAgent.set(key, value);
        return this;
    }

    reset = async (key=null) => {
        await this.storageAgent.reset(key);
        return this;
    }

    subscribe = async (key, onChange) => {
        return await this.storageAgent.subscribe(key, onChange);
    }
}

export default SharedStorageQiankun;